import {GoogleAnalytics} from '../../../../application/analytics/googleAnalytics';

class OfferAnalytics extends GoogleAnalytics{
    sendEvent(name) {
        this._send('offer', name);
    }

    sendViewEvent() {
        this.sendEvent('view');
    }

    sendClickShareEvent() {
        this.sendEvent('click-share');
    }

    sendClickCodeEvent() {
        this.sendEvent('click-code');
    }
}

export {OfferAnalytics};
